
<template>
  <v-app-bar app color="#385F73" dark fixed>
    <v-app-bar-nav-icon @click.stop="showMenu"></v-app-bar-nav-icon>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-h6"> LMS </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-menu
      v-if="user.isLoggedin"
      style="max-height: 450px !important"
      v-model="menu"
      :nudge-width="150"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          :content="notificationCounter"
          :value="notificationCounter"
          color="green"
          offset-x="20"
          offset-y="20"
        >
          <v-btn @click="clearCounter" icon link v-bind="attrs" v-on="on">
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </v-badge>
      </template>

      <v-card>
        <v-list
          v-if="notificationMessage.length > 0"
          class="notification-appbar"
        >
          <template v-for="(item, index) in notificationMessage">
            <v-list-item :key="index" style="width: 300px">
              <v-avatar
                color="hsl(180deg 51% 52%)"
                style="margin-top: -20px"
                elevation="1"
                size="25"
                class="mr-2"
              >
                <span class="white--text" v-if="item.from">{{
                  item.from[0].toUpperCase()
                }}</span>
              </v-avatar>

              <v-list-item-content>
                <h5>
                  <v-row>
                    <v-col md="6" cols="12" style="font-size: 12px">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">{{
                            item.from.length > 15
                              ? `${item.from.substring(0, 15)}...`
                              : item.from
                          }}</span>
                        </template>
                        <span>{{ item.from }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col
                      md="6"
                      cols="12"
                      style="font-size: 8px; text-align: right"
                    >
                      <span
                        ><i>{{ timeSince(item.time) }}</i></span
                      >
                    </v-col>
                  </v-row>
                </h5>
                <v-list-item-subtitle
                  style="
                    white-space: break-spaces;
                    margin-top: 2px;
                    font-size: 12px;
                  "
                  v-html="item.message"
                >
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <div
              :key="index + '' + 'div'"
              style="margin-left: 60px; margin-right: 20px"
            >
              <v-divider></v-divider>
            </div>
          </template>
        </v-list>
        <v-card-text v-else> No notifications</v-card-text>
      </v-card>
    </v-menu>

    <div style="margin-left: 20px; white-space: nowrap" v-if="user.isLoggedin">
      <v-avatar color="#223640" elevation="1" size="30" class="mr-2">
        <span class="white--text" v-if="userName">{{
          userName[0]
        }}</span> </v-avatar
      >{{ userName }}
    </div>

    <v-menu top v-if="user.isLoggedin">
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="clearCounter" icon link v-bind="attrs" v-on="on">
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="profile" link>
          <v-icon>mdi-account-circle</v-icon>
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout" link>
          <v-icon>mdi-logout</v-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- <v-btn icon link @click="logout"><v-icon>mdi-logout</v-icon></v-btn> -->
  </v-app-bar>
</template>

<script >
import Vue from "vue";

export default Vue.extend({
  name: "AppBar",
  components: {},
  data() {
    return {
      menu: null,
      userName: "",
    };
  },
  watch: {
    "$store.state.user.user": {
      handler(value) {
        this.userName = value.username;
      },
      deep: true,
    },
  },
  mounted() {
    this.$store.dispatch("showMenu", true);
    this.userName = this.$store.state.user.user.username;
  },
  computed: {
    orderStatus() {
      return this.$store.state.masters.orderStatus;
    },
    user() {
      return this.$store.state.user.user;
    },
    notificationCounter() {
      return this.$store.state.notification.counter;
    },
    notificationMessage() {
      return this.$store.state.notification.notification
        .map((e) => ({
          from: e.UserName == this.userName ? "You" : e.UserName,
          time: e.Time,
          message: e.Message,
          color: e.Color != null ? e.Color : this.getColor(e.Status),
          dateTime: e.Time,
        }))
        .sort(this.customSort);
    },
  },
  created: function () {
    window.addEventListener("focus", this.updateUserName(), false);
  },

  methods: {
    updateUserName() {
      this.userName = this.$store.state.user.user.username;
    },
    closeOnClick() {
      return;
    },
    customSort(a, b) {
      return new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime();
    },
    timeSince(date) {
      return Date.showLocalFullSec(date);
      // var seconds = Math.floor((new Date() - new Date(date)) / 1000);
      // var interval = seconds / 31536000;

      // if (interval > 1) {
      //   return Date.showLocal(date);
      // }
      // interval = seconds / 2592000;
      // if (interval > 1) {
      //   return Date.showLocalShort(date);
      // }
      // interval = seconds / 86400;
      // if (interval > 1) {
      //   return Date.showLocalShort(date);
      // }
      // interval = seconds / 3600;
      // if (interval > 1) {
      //   return Math.floor(interval) + " hrs ago";
      // }
      // interval = seconds / 60;
      // if (interval > 1) {
      //   return Math.floor(interval) + " min ago";
      // }
      // return Math.floor(seconds) + " sec ago";
    },
    getStatusText(status) {
      let type = this.orderStatus.find((e) => e.value == status);
      return type ? type.text : "";
    },
    getColor(status) {
      let type = this.orderStatus.find((e) => e.value == status);
      return type ? type.color : "success";
    },
    async logout() {
      await this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    profile() {
      this.$router.push("/profile");
    },
    clearCounter() {
      this.$store.dispatch("clearCounter");
    },
    showMenu() {
      let data = this.user.menu ? false : true;
      this.$store.dispatch("showMenu", data);
    },
  },
});
</script>


<style>
.notification-appbar {
  max-height: 500px;
  overflow: auto;
}
.notification-appbar .v-chip.v-chip--outlined {
  border-style: none;
  font-size: 12px;
  height: 20px;
  padding-left: 5px;
  padding-right: 5px;
}

.notification-appbar .v-icon {
  font-size: 20px !important;
}
.notification-appbar.v-list-item__subtitle {
  font-size: 12px !important;
}
</style>